const PILLS = [
  { id: "all", label: "All" },
  { id: "Wall Mounted", label: "Wall Mounted" },
  { id: "Floor Mounted", label: "Floor Mounted" },
];

// Reflects/controls the mounting filter as a single-select top-level split.
export const CategoryPills = ({ mounting, onSelect }) => {
  const active =
    mounting.length === 1 ? mounting[0] : "all"; // both or none => "All"

  return (
    <div
      data-testid="category-pills"
      className="flex gap-2.5 overflow-x-auto pb-1 -mx-1 px-1 no-scrollbar"
    >
      {PILLS.map((p) => {
        const isActive = active === p.id;
        return (
          <button
            key={p.id}
            onClick={() => onSelect(p.id)}
            data-testid={`pill-${p.id.toLowerCase().replace(/\s+/g, "-")}`}
            aria-pressed={isActive}
            className={`whitespace-nowrap rounded-full border px-6 py-2.5 text-sm font-medium transition-colors duration-300 ${
              isActive
                ? "bg-charcoal text-ivory border-charcoal"
                : "bg-transparent text-charcoal border-beige hover:border-charcoal"
            }`}
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
};
